import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import Loading from '../../shared/components/misc/Loading';
import CheckBox from '../../shared/components/forms/CheckBox';
import { getBusinessAccountConsentUrl, openBusinessAccount } from "../actions";

class BusinessAccountOpeningContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      netbankAgreement: false,
      firstCircleAgreement: false
    }
  }

  componentDidUpdate() {
    if (!this.state.netbankAgreement && this.props.netbankAgreementsConsented) {
      this.setState({ netbankAgreement: this.props.netbankAgreementsConsented });
    }

    if (!this.state.firstCircleAgreement && this.props.firstCircleAgreementsConsented) {
      this.setState({ firstCircleAgreement: this.props.firstCircleAgreementsConsented });
    }
  }

  renderFCTermsAndCondition() {
    return (
      <span className='small label -darkBlue'>I agree to
        <a target='_blank' rel="noopener noreferrer" className='' href='https://docs.google.com/document/d/195etVZTPwx7icGdjwRtbsBM-0sm2EHap1fionsETGow/view'> First Circle's Terms and Condition
        </a> and <a target='_blank' rel="noopener noreferrer" href='https://docs.google.com/document/d/1Wtxbzkn-TN2w5jKVaLse7-oNTYy1t0--Ik1w5K57mtI/view'>Privacy Policy </a>
      </span>
    )
  }

  renderNetBankTermsAndCondition() {
    return (
      <span className='small label -darkBlue'>I agree to <a target='_blank' rel="noopener noreferrer" href='https://docs.google.com/document/d/1jzbL3q3UMtbjXz1a43ykSD2BwjkyslnWihTzLZxJAmw/view'>Netbank's Terms  and Condition </a> and <a target='_blank' rel="noopener noreferrer" href='https://docs.google.com/document/d/18cAGDe7bOV9_joY0h9aPqFU6wa0F_TX7mTnu_tPR2cw/view'>Privacy Policy </a></span>
    )
  }
  get shouldRenderNothing() {
    const {
      fetchingBusinessAccountState,
      businessAccountEnabled,
      businessAccountCreated,
      withBusinessAccountConsent
    } = this.props;

    if (!fetchingBusinessAccountState && !businessAccountEnabled) return true;

    return !fetchingBusinessAccountState
      && businessAccountEnabled
      && businessAccountCreated
      && withBusinessAccountConsent;
  }

  renderCreateBusinessAccount() {
    const disabledCreateButton = this.props.openingBusinessAccount
      || !this.state.netbankAgreement
      || !this.state.firstCircleAgreement;

    const create = () => {
      this.props.openBusinessAccount({
        netbank_consent: this.state.netbankAgreement,
        first_circle_consent: this.state.firstCircleAgreement
      })
    }

    return (
      <Fragment>
        <div className='_textAlign_center _padding--small'>
          <p className='_fontSize--xlarge _fontWeight_bold -primary _marginBottom--small'>Open your business account in minutes</p>
          <small className=' copy '>Free, powerful, secure banking for your business <span role="img" aria-label="party" >🎉</span></small>
        </div>
        <div className='_displayFlex _flexColumn _padding--large _paddingTop--none _paddingBottom--none _marginTop--small'>
          <CheckBox
            id="firstCircleAgreement"
            className='_marginBottom--xxxsmall _alignLeft _marginRight--xsmall '
            checked={this.state.firstCircleAgreement}
            onChange={(e) => this.setState({ firstCircleAgreement: e.target.checked })}
            label={this.renderFCTermsAndCondition()}
          />
          <CheckBox
            id="netbankAgreement"
            checked={this.state.netbankAgreement}
            className='_alignLeft  _marginRight--xsmall'
            onChange={(e) => this.setState({ netbankAgreement: e.target.checked })}
            label={this.renderNetBankTermsAndCondition()}
          />
        </div>
        <div className='_marginTop--xxsmall _alignCenter _padding--small'>
          <p className='copy _alignCenter'>Netbank is a banking provider we're partnering with to provide our banking services.</p>
        </div>

        {this.props.openingBusinessAccount && (
          <div className="animatedDot _marginTop--medium"><span></span></div>
        )}

        <div className="_textAlign_center">
          <button
            onClick={create}
            className='ds-btn -primary --block _marginTop--small'
            disabled={disabledCreateButton}
          >
            Open Account
          </button>
        </div>
      </Fragment >
    )
  }

  renderBusinessAccountConsent() {
    return (
      <div className='_displayFlex _flexColumn _padding--small'>
        <p className='_marginTop--small _fontSize--xlarge _fontWeight_bold -primary'>Just one more step!</p>
        <h3 className='subhead -darkBlue _padding--small'>Netbank (our banking partner) need you to pass a security check</h3>
        <p className=' copy'>Important: Please provide these security questions</p>
        <div className="ds-dataSet _displayFlex _marginTop--xxsmall _width--50 margin--auto-">
          <div className="ds-data _displayFlex  --block _margin--none _paddingLeft--small ">
            <div className='_width--50 _alignLeft'>
              <small className="dataName _marginRight--xsmall">Date of birth: </small>
            </div>
            <div className='_width--50 _alignLeft'>
              <p className="data"><span class="sub">{this.props.dateOfBirth || '-'}</span></p>
            </div>
          </div>
          <div className="ds-data _displayFlex  --block _margin--none _paddingLeft--small ">
            <div className='_width--50 _alignLeft'>
              <small className="dataName _marginRight--xsmall">Place of birth: </small>
            </div>
            <div className='_width--50 _alignLeft'>
              <p className="data"><span class="sub">{this.props.placeOfBirth || '-'}</span></p>
            </div>
          </div>
          <div className="ds-data _displayFlex  --block _margin--none _paddingLeft--small " >
            <div className='_width--50 _alignLeft'>
              <small className="dataName _marginRight--xsmall" >First Name: </small>
            </div>
            <div className='_width--50 _alignLeft'>
              <p className="data"><span class="sub">{this.props.firstName || '-'}</span></p>
            </div>
          </div>
        </div>
        {this.props.fetchingConsentUrl && (
          <div className="animatedDot _marginTop--medium"><span></span></div>
        )}
        <button
          onClick={this.props.getBusinessAccountConsentUrl}
          className='ds-btn -primary _margin--auto _marginTop--normal _loading --block'
          disabled={this.props.fetchingConsentUrl}
        >
          Continue
        </button>
      </div>
    )
  }

  renderError() {
    return (
      <Fragment>
        <div className=''>
          <p className='_fontWeight_bold -danger _fontSize--large'>Sorry, something went wrong!</p>
          <p className='_marginTop--small -primary _fontWeight_bold'>Please reach out to customer support</p>
        </div>
        <div className='_marginTop--small _displayFlex _alignItems-center _justifyContent-center _gap--10px _flexWrap--wrap'>
          <a className='ds-btn _link -base' href="mailto:support@firstcircle.com">
            <i class="materialIcon --xxsmall _margin--zero-imp">mail</i>
            <span className="_marginLeft--xxsmall">support@firstcircle.com</span>
          </a>
          <a href='tel:+63285803200' className='ds-btn _link -base'>
            <i class="materialIcon --xxsmall _margin--zero-imp" >phone</i>
            <span className="_marginLeft--xxsmall">(+632) 8580 3200</span>
          </a>
          <a href='tel:+639189857937' className='ds-btn _link -base'>
            <i class="materialIcon --xxsmall _margin--zero-imp">phone_iphone</i>
            <span className="_marginLeft--xxsmall">(+63) 918 985 7937</span>
          </a>
        </div>
      </Fragment>
    )
  }

  renderCurrentView() {
    const {
      fetchingBusinessAccountState,
      businessAccountCreated,
      businessAccountEnabled,
      openBusinessAccountError,
      businessAccountStateError,
      businessAccountConsentError,
      withBusinessAccountConsent
    } = this.props;

    if (fetchingBusinessAccountState) {
      return <Loading />
    }

    if (openBusinessAccountError || businessAccountStateError || businessAccountConsentError) {
      return this.renderError()
    }

    if (businessAccountEnabled && businessAccountCreated && !withBusinessAccountConsent) {
      return this.renderBusinessAccountConsent()
    }

    if (businessAccountEnabled && !businessAccountCreated) {
      return this.renderCreateBusinessAccount()
    }
  }

  render() {
    if (this.shouldRenderNothing) return null;

    return (
      <section
        className='cardSection ds-card _padding--large _textAlign_center _borderRadiusTop'
        data-testid="business-account-opening-card"
      >
        {this.renderCurrentView()}
      </section>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    firstName: state.businessAccount.firstName,
    dateOfBirth: state.businessAccount.dateOfBirth,
    placeOfBirth: state.businessAccount.placeOfBirth,
    fetchingConsentUrl: state.businessAccount.fetchingBusinessAccountConsent,
    fetchingBusinessAccountState: state.businessAccount.fetchingBusinessAccountState,
    businessAccountEnabled: state.businessAccount.businessAccountEnabled,
    businessAccountCreated: state.businessAccount.businessAccountCreated,
    withBusinessAccountConsent: state.businessAccount.withBusinessAccountConsent,
    openingBusinessAccount: state.businessAccount.openingBusinessAccount,
    openBusinessAccountError: state.businessAccount.openBusinessAccountError,
    businessAccountStateError: state.businessAccount.businessAccountStateError,
    businessAccountConsentError: state.businessAccount.businessAccountConsentError,
    netbankAgreementsConsented: state.businessAccount.netbankAgreementsConsented,
    firstCircleAgreementsConsented: state.businessAccount.firstCircleAgreementsConsented,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getBusinessAccountConsentUrl: () => dispatch(getBusinessAccountConsentUrl()),
    openBusinessAccount: (params) => dispatch(openBusinessAccount(params))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BusinessAccountOpeningContainer);



// WEBPACK FOOTER //
// ./src/features/business_account/components/BusinessAccountOpeningContainer.js